export const GITHUB_CLIENT_ID = process.env.REACT_APP_GITHUB_CLIENT_ID;

export const GIST_FILENAME = 'script.turf-sandbox';

export const GITHUB_API = 'https://api.github.com';

export const url = new URL(window.location.href);
